import { defaultHttpClient } from 'shared/src/api/httpClient';

export const removeBookmarkOutfit = (sno: number) => {
  return defaultHttpClient
    .request<void>({
      method: 'DELETE',
      url: `/api/v2/outfits/${sno}/bookmark/`,
    })
    .then(result => result.data);
};
